import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { Button, cx } from '../components';
import { useLogout, useSession } from '../hooks/use-auth';
import { ThemeToggle } from '../features/theme/ThemeToggle';

const NAV_ITEMS = [
  { to: '/', label: 'Dashboard', end: true },
  { to: '/pesquisas/nova', label: 'Nova pesquisa', end: false },
  { to: '/historico', label: 'Histórico', end: false },
  { to: '/exportacoes', label: 'Exportações', end: false },
];

export function AppLayout() {
  const { data } = useSession();
  const logout = useLogout();
  const navigate = useNavigate();

  const handleLogout = async (): Promise<void> => {
    await logout.mutateAsync().catch(() => undefined);
    navigate('/login', { replace: true });
  };

  return (
    <div className="min-h-screen">
      {/* Link de pulo: primeiro alvo do Tab, essencial para teclado (RNF-F05). */}
      <a
        href="#conteudo"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-10 focus:rounded-md focus:bg-surface focus:px-4 focus:py-2"
      >
        Pular para o conteúdo
      </a>

      <header className="border-b border-border bg-surface">
        <div className="mx-auto flex max-w-content flex-wrap items-center gap-4 px-4 py-3">
          <span className="text-base font-semibold text-text">Pesquisa Social</span>

          <nav aria-label="Principal" className="flex flex-1 flex-wrap gap-1">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  cx(
                    'rounded-md px-3 py-1 text-sm transition-colors',
                    isActive
                      ? 'bg-accent-soft text-accent'
                      : 'text-text-muted hover:bg-surface-raised',
                  )
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <ThemeToggle />
            {data?.user && (
              <span className="hidden text-sm text-text-muted sm:inline">{data.user.name}</span>
            )}
            <Button variant="ghost" size="sm" onClick={handleLogout} loading={logout.isPending}>
              Sair
            </Button>
          </div>
        </div>
      </header>

      <main id="conteudo" className="mx-auto max-w-content px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
